import React from 'react';

/** Issue chips → serviceType + clusterId (mirrors backend SERVICE_TYPE_TO_CLUSTER). */
export const GARAGE_ISSUE_OPTIONS = [
  { id: '', label: 'All issues', serviceType: '', clusterId: null },
  { id: 'ac', label: 'AC not cooling', serviceType: 'AC Service', clusterId: 5 },
  { id: 'brakes', label: 'Brakes / noise', serviceType: 'Brakes', clusterId: 4 },
  { id: 'full', label: 'Periodic service', serviceType: 'Full Service', clusterId: 1 },
  { id: 'suspension', label: 'Suspension', serviceType: 'Suspension', clusterId: 4 },
  { id: 'electrical', label: 'Battery / lights', serviceType: 'Electricals', clusterId: 2 },
  { id: 'body', label: 'Dent / paint', serviceType: 'Denting & Painting', clusterId: 8 },
];

/**
 * Multi-select issue picker for split-cart discovery (Phase 6).
 * `value` is an array of issue ids (empty = all issues).
 */
export default function GarageServiceIssuePicker({ value = [], onChange }) {
  const selectedIds = Array.isArray(value) ? value.filter(Boolean) : value ? [value] : [];

  const toggle = (issue) => {
    if (!issue.id) {
      onChange?.([]);
      return;
    }
    const exists = selectedIds.includes(issue.id);
    const next = exists
      ? selectedIds.filter((id) => id !== issue.id)
      : [...selectedIds, issue.id];
    onChange?.(next);
  };

  return (
    <div>
      <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
        What&apos;s wrong?
      </p>
      <p className="mb-2 text-[11px] text-gray-500">
        Select one or more issues. If no single garage covers all, we&apos;ll suggest a split booking.
      </p>
      <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide snap-x snap-mandatory">
        {GARAGE_ISSUE_OPTIONS.map((issue) => {
          const active = issue.id
            ? selectedIds.includes(issue.id)
            : selectedIds.length === 0;
          return (
            <button
              key={issue.id || 'all'}
              type="button"
              onClick={() => toggle(issue)}
              className={`snap-start shrink-0 rounded-full border px-3 py-2 text-xs font-semibold transition sm:text-sm ${
                active
                  ? 'border-blue-600 bg-blue-600 text-white'
                  : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300'
              }`}
            >
              {issue.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
